import { FieldObjectType, InputType, ValidationType } from "interfaces";

export const NATIONALITIES_OBJECT = {
  Vietnam: {
    label: {
      en: "Vietnamese",
      vi: "Việt Nam",
    },
  },
  afghanistan: {
    label: {
      en: "Afghanistan",
      vi: "Afghanistan",
    },
  },
  aland_islands: {
    label: {
      en: "Åland Islands",
      vi: "Åland Islands",
    },
  },
  albania: {
    label: {
      en: "Albania",
      vi: "Albania",
    },
  },
  algeria: {
    label: {
      en: "Algeria",
      vi: "Algeria",
    },
  },
  american_samoa: {
    label: {
      en: "American Samoa",
      vi: "American Samoa",
    },
  },
  andorra: {
    label: {
      en: "Andorra",
      vi: "Andorra",
    },
  },
  angola: {
    label: {
      en: "Angola",
      vi: "Angola",
    },
  },
  anguilla: {
    label: {
      en: "Anguilla",
      vi: "Anguilla",
    },
  },
  antarctica: {
    label: {
      en: "Antarctica",
      vi: "Antarctica",
    },
  },
  antigua_and_barbuda: {
    label: {
      en: "Antigua and Barbuda",
      vi: "Antigua and Barbuda",
    },
  },
  argentina: {
    label: {
      en: "Argentina",
      vi: "Argentina",
    },
  },
  armenia: {
    label: {
      en: "Armenia",
      vi: "Armenia",
    },
  },
  aruba: {
    label: {
      en: "Aruba",
      vi: "Aruba",
    },
  },
  australia: {
    label: {
      en: "Australia",
      vi: "Australia",
    },
  },
  austria: {
    label: {
      en: "Austria",
      vi: "Austria",
    },
  },
  azerbaijan: {
    label: {
      en: "Azerbaijan",
      vi: "Azerbaijan",
    },
  },
  bahamas: {
    label: {
      en: "Bahamas",
      vi: "Bahamas",
    },
  },
  bahrain: {
    label: {
      en: "Bahrain",
      vi: "Bahrain",
    },
  },
  bangladesh: {
    label: {
      en: "Bangladesh",
      vi: "Bangladesh",
    },
  },
  barbados: {
    label: {
      en: "Barbados",
      vi: "Barbados",
    },
  },
  belarus: {
    label: {
      en: "Belarus",
      vi: "Belarus",
    },
  },
  belgium: {
    label: {
      en: "Belgium",
      vi: "Belgium",
    },
  },
  belize: {
    label: {
      en: "Belize",
      vi: "Belize",
    },
  },
  benin: {
    label: {
      en: "Benin",
      vi: "Benin",
    },
  },
  bermuda: {
    label: {
      en: "Bermuda",
      vi: "Bermuda",
    },
  },
  bhutan: {
    label: {
      en: "Bhutan",
      vi: "Bhutan",
    },
  },
  bolivia: {
    label: {
      en: "Bolivia",
      vi: "Bolivia",
    },
  },
  bosnia_and_herzegovina: {
    label: {
      en: "Bosnia and Herzegovina",
      vi: "Bosnia and Herzegovina",
    },
  },
  botswana: {
    label: {
      en: "Botswana",
      vi: "Botswana",
    },
  },
  bouvet_island: {
    label: {
      en: "Bouvet Island",
      vi: "Bouvet Island",
    },
  },
  brazil: {
    label: {
      en: "Brazil",
      vi: "Brazil",
    },
  },
  british_indian_ocean_territory: {
    label: {
      en: "British Indian Ocean Territory",
      vi: "British Indian Ocean Territory",
    },
  },
  brunei_darussalam: {
    label: {
      en: "Brunei Darussalam",
      vi: "Brunei Darussalam",
    },
  },
  bulgaria: {
    label: {
      en: "Bulgaria",
      vi: "Bulgaria",
    },
  },
  burkina_faso: {
    label: {
      en: "Burkina Faso",
      vi: "Burkina Faso",
    },
  },
  burundi: {
    label: {
      en: "Burundi",
      vi: "Burundi",
    },
  },
  cambodia: {
    label: {
      en: "Cambodia",
      vi: "Cambodia",
    },
  },
  cameroon: {
    label: {
      en: "Cameroon",
      vi: "Cameroon",
    },
  },
  canada: {
    label: {
      en: "Canada",
      vi: "Canada",
    },
  },
  cape_verde: {
    label: {
      en: "Cape Verde",
      vi: "Cape Verde",
    },
  },
  cayman_islands: {
    label: {
      en: "Cayman Islands",
      vi: "Cayman Islands",
    },
  },
  central_african_republic: {
    label: {
      en: "Central African Republic",
      vi: "Central African Republic",
    },
  },
  chad: {
    label: {
      en: "Chad",
      vi: "Chad",
    },
  },
  chile: {
    label: {
      en: "Chile",
      vi: "Chile",
    },
  },
  china: {
    label: {
      en: "China",
      vi: "China",
    },
  },
  christmas_island: {
    label: {
      en: "Christmas Island",
      vi: "Christmas Island",
    },
  },
  cocos_keeling_islands: {
    label: {
      en: "Cocos (Keeling) Islands",
      vi: "Cocos (Keeling) Islands",
    },
  },
  colombia: {
    label: {
      en: "Colombia",
      vi: "Colombia",
    },
  },
  comoros: {
    label: {
      en: "Comoros",
      vi: "Comoros",
    },
  },
  congo: {
    label: {
      en: "Congo",
      vi: "Congo",
    },
  },
  congo_the_democratic_republic_of_the: {
    label: {
      en: "Congo, The Democratic Republic of the",
      vi: "Congo, The Democratic Republic of the",
    },
  },
  cook_islands: {
    label: {
      en: "Cook Islands",
      vi: "Cook Islands",
    },
  },
  costa_rica: {
    label: {
      en: "Costa Rica",
      vi: "Costa Rica",
    },
  },
  cote_d_ivoire: {
    label: {
      en: "Cote D'Ivoire",
      vi: "Cote D'Ivoire",
    },
  },
  croatia: {
    label: {
      en: "Croatia",
      vi: "Croatia",
    },
  },
  cuba: {
    label: {
      en: "Cuba",
      vi: "Cuba",
    },
  },
  cyprus: {
    label: {
      en: "Cyprus",
      vi: "Cyprus",
    },
  },
  czech_republic: {
    label: {
      en: "Czech Republic",
      vi: "Czech Republic",
    },
  },
  denmark: {
    label: {
      en: "Denmark",
      vi: "Denmark",
    },
  },
  djibouti: {
    label: {
      en: "Djibouti",
      vi: "Djibouti",
    },
  },
  dominica: {
    label: {
      en: "Dominica",
      vi: "Dominica",
    },
  },
  dominican_republic: {
    label: {
      en: "Dominican Republic",
      vi: "Dominican Republic",
    },
  },
  ecuador: {
    label: {
      en: "Ecuador",
      vi: "Ecuador",
    },
  },
  egypt: {
    label: {
      en: "Egypt",
      vi: "Egypt",
    },
  },
  el_salvador: {
    label: {
      en: "El Salvador",
      vi: "El Salvador",
    },
  },
  equatorial_guinea: {
    label: {
      en: "Equatorial Guinea",
      vi: "Equatorial Guinea",
    },
  },
  eritrea: {
    label: {
      en: "Eritrea",
      vi: "Eritrea",
    },
  },
  estonia: {
    label: {
      en: "Estonia",
      vi: "Estonia",
    },
  },
  ethiopia: {
    label: {
      en: "Ethiopia",
      vi: "Ethiopia",
    },
  },
  falkland_islands_malvinas: {
    label: {
      en: "Falkland Islands (Malvinas)",
      vi: "Falkland Islands (Malvinas)",
    },
  },
  faroe_islands: {
    label: {
      en: "Faroe Islands",
      vi: "Faroe Islands",
    },
  },
  fiji: {
    label: {
      en: "Fiji",
      vi: "Fiji",
    },
  },
  finland: {
    label: {
      en: "Finland",
      vi: "Finland",
    },
  },
  france: {
    label: {
      en: "France",
      vi: "France",
    },
  },
  french_guiana: {
    label: {
      en: "French Guiana",
      vi: "French Guiana",
    },
  },
  french_polynesia: {
    label: {
      en: "French Polynesia",
      vi: "French Polynesia",
    },
  },
  french_southern_territories: {
    label: {
      en: "French Southern Territories",
      vi: "French Southern Territories",
    },
  },
  gabon: {
    label: {
      en: "Gabon",
      vi: "Gabon",
    },
  },
  gambia: {
    label: {
      en: "Gambia",
      vi: "Gambia",
    },
  },
  georgia: {
    label: {
      en: "Georgia",
      vi: "Georgia",
    },
  },
  germany: {
    label: {
      en: "Germany",
      vi: "Germany",
    },
  },
  ghana: {
    label: {
      en: "Ghana",
      vi: "Ghana",
    },
  },
  gibraltar: {
    label: {
      en: "Gibraltar",
      vi: "Gibraltar",
    },
  },
  greece: {
    label: {
      en: "Greece",
      vi: "Greece",
    },
  },
  greenland: {
    label: {
      en: "Greenland",
      vi: "Greenland",
    },
  },
  grenada: {
    label: {
      en: "Grenada",
      vi: "Grenada",
    },
  },
  guadeloupe: {
    label: {
      en: "Guadeloupe",
      vi: "Guadeloupe",
    },
  },
  guam: {
    label: {
      en: "Guam",
      vi: "Guam",
    },
  },
  guatemala: {
    label: {
      en: "Guatemala",
      vi: "Guatemala",
    },
  },
  guernsey: {
    label: {
      en: "Guernsey",
      vi: "Guernsey",
    },
  },
  guinea: {
    label: {
      en: "Guinea",
      vi: "Guinea",
    },
  },
  "guinea-bissau": {
    label: {
      en: "Guinea-Bissau",
      vi: "Guinea-Bissau",
    },
  },
  guyana: {
    label: {
      en: "Guyana",
      vi: "Guyana",
    },
  },
  haiti: {
    label: {
      en: "Haiti",
      vi: "Haiti",
    },
  },
  heard_island_and_mcdonald_islands: {
    label: {
      en: "Heard Island and Mcdonald Islands",
      vi: "Heard Island and Mcdonald Islands",
    },
  },
  "holy_see_(vatican_city_state)": {
    label: {
      en: "Holy See (Vatican City State)",
      vi: "Holy See (Vatican City State)",
    },
  },
  honduras: {
    label: {
      en: "Honduras",
      vi: "Honduras",
    },
  },
  hong_kong: {
    label: {
      en: "Hong Kong",
      vi: "Hong Kong",
    },
  },
  hungary: {
    label: {
      en: "Hungary",
      vi: "Hungary",
    },
  },
  iceland: {
    label: {
      en: "Iceland",
      vi: "Iceland",
    },
  },
  india: {
    label: {
      en: "India",
      vi: "India",
    },
  },
  indonesia: {
    label: {
      en: "Indonesia",
      vi: "Indonesia",
    },
  },
  "iran,_islamic_republic_of": {
    label: {
      en: "Iran, Islamic Republic Of",
      vi: "Iran, Islamic Republic Of",
    },
  },
  iraq: {
    label: {
      en: "Iraq",
      vi: "Iraq",
    },
  },
  ireland: {
    label: {
      en: "Ireland",
      vi: "Ireland",
    },
  },
  isle_of_man: {
    label: {
      en: "Isle of Man",
      vi: "Isle of Man",
    },
  },
  israel: {
    label: {
      en: "Israel",
      vi: "Israel",
    },
  },
  italy: {
    label: {
      en: "Italy",
      vi: "Italy",
    },
  },
  jamaica: {
    label: {
      en: "Jamaica",
      vi: "Jamaica",
    },
  },
  japan: {
    label: {
      en: "Japan",
      vi: "Japan",
    },
  },
  jersey: {
    label: {
      en: "Jersey",
      vi: "Jersey",
    },
  },
  jordan: {
    label: {
      en: "Jordan",
      vi: "Jordan",
    },
  },
  kazakhstan: {
    label: {
      en: "Kazakhstan",
      vi: "Kazakhstan",
    },
  },
  kenya: {
    label: {
      en: "Kenya",
      vi: "Kenya",
    },
  },
  kiribati: {
    label: {
      en: "Kiribati",
      vi: "Kiribati",
    },
  },
  democratic_people_s_republic_of_korea: {
    label: {
      en: "Democratic People's Republic of Korea",
      vi: "Democratic People's Republic of Korea",
    },
  },
  korea_republic_of: {
    label: {
      en: "Korea, Republic of",
      vi: "Korea, Republic of",
    },
  },
  kosovo: {
    label: {
      en: "Kosovo",
      vi: "Kosovo",
    },
  },
  kuwait: {
    label: {
      en: "Kuwait",
      vi: "Kuwait",
    },
  },
  kyrgyzstan: {
    label: {
      en: "Kyrgyzstan",
      vi: "Kyrgyzstan",
    },
  },
  lao_people_s_democratic_republic: {
    label: {
      en: "Lao People's Democratic Republic",
      vi: "Lao People's Democratic Republic",
    },
  },
  latvia: {
    label: {
      en: "Latvia",
      vi: "Latvia",
    },
  },
  lebanon: {
    label: {
      en: "Lebanon",
      vi: "Lebanon",
    },
  },
  lesotho: {
    label: {
      en: "Lesotho",
      vi: "Lesotho",
    },
  },
  liberia: {
    label: {
      en: "Liberia",
      vi: "Liberia",
    },
  },
  libyan_arab_jamahiriya: {
    label: {
      en: "Libyan Arab Jamahiriya",
      vi: "Libyan Arab Jamahiriya",
    },
  },
  liechtenstein: {
    label: {
      en: "Liechtenstein",
      vi: "Liechtenstein",
    },
  },
  lithuania: {
    label: {
      en: "Lithuania",
      vi: "Lithuania",
    },
  },
  luxembourg: {
    label: {
      en: "Luxembourg",
      vi: "Luxembourg",
    },
  },
  macao: {
    label: {
      en: "Macao",
      vi: "Macao",
    },
  },
  macedonia_the_former_yugoslav_republic_of: {
    label: {
      en: "Macedonia, The Former Yugoslav Republic of",
      vi: "Macedonia, The Former Yugoslav Republic of",
    },
  },
  madagascar: {
    label: {
      en: "Madagascar",
      vi: "Madagascar",
    },
  },
  malawi: {
    label: {
      en: "Malawi",
      vi: "Malawi",
    },
  },
  malaysia: {
    label: {
      en: "Malaysia",
      vi: "Malaysia",
    },
  },
  maldives: {
    label: {
      en: "Maldives",
      vi: "Maldives",
    },
  },
  mali: {
    label: {
      en: "Mali",
      vi: "Mali",
    },
  },
  malta: {
    label: {
      en: "Malta",
      vi: "Malta",
    },
  },
  marshall_islands: {
    label: {
      en: "Marshall Islands",
      vi: "Marshall Islands",
    },
  },
  martinique: {
    label: {
      en: "Martinique",
      vi: "Martinique",
    },
  },
  mauritania: {
    label: {
      en: "Mauritania",
      vi: "Mauritania",
    },
  },
  mauritius: {
    label: {
      en: "Mauritius",
      vi: "Mauritius",
    },
  },
  mayotte: {
    label: {
      en: "Mayotte",
      vi: "Mayotte",
    },
  },
  mexico: {
    label: {
      en: "Mexico",
      vi: "Mexico",
    },
  },
  micronesia_federated_states_of: {
    label: {
      en: "Micronesia, Federated States of",
      vi: "Micronesia, Federated States of",
    },
  },
  "moldova,_republic_of": {
    label: {
      en: "Moldova, Republic of",
      vi: "Moldova, Republic of",
    },
  },
  monaco: {
    label: {
      en: "Monaco",
      vi: "Monaco",
    },
  },
  mongolia: {
    label: {
      en: "Mongolia",
      vi: "Mongolia",
    },
  },
  montenegro: {
    label: {
      en: "Montenegro",
      vi: "Montenegro",
    },
  },
  montserrat: {
    label: {
      en: "Montserrat",
      vi: "Montserrat",
    },
  },
  morocco: {
    label: {
      en: "Morocco",
      vi: "Morocco",
    },
  },
  mozambique: {
    label: {
      en: "Mozambique",
      vi: "Mozambique",
    },
  },
  myanmar: {
    label: {
      en: "Myanmar",
      vi: "Myanmar",
    },
  },
  namibia: {
    label: {
      en: "Namibia",
      vi: "Namibia",
    },
  },
  nauru: {
    label: {
      en: "Nauru",
      vi: "Nauru",
    },
  },
  nepal: {
    label: {
      en: "Nepal",
      vi: "Nepal",
    },
  },
  netherlands: {
    label: {
      en: "Netherlands",
      vi: "Netherlands",
    },
  },
  netherlands_antilles: {
    label: {
      en: "Netherlands Antilles",
      vi: "Netherlands Antilles",
    },
  },
  new_caledonia: {
    label: {
      en: "New Caledonia",
      vi: "New Caledonia",
    },
  },
  new_zealand: {
    label: {
      en: "New Zealand",
      vi: "New Zealand",
    },
  },
  nicaragua: {
    label: {
      en: "Nicaragua",
      vi: "Nicaragua",
    },
  },
  niger: {
    label: {
      en: "Niger",
      vi: "Niger",
    },
  },
  nigeria: {
    label: {
      en: "Nigeria",
      vi: "Nigeria",
    },
  },
  niue: {
    label: {
      en: "Niue",
      vi: "Niue",
    },
  },
  norfolk_island: {
    label: {
      en: "Norfolk Island",
      vi: "Norfolk Island",
    },
  },
  northern_mariana_islands: {
    label: {
      en: "Northern Mariana Islands",
      vi: "Northern Mariana Islands",
    },
  },
  norway: {
    label: {
      en: "Norway",
      vi: "Norway",
    },
  },
  oman: {
    label: {
      en: "Oman",
      vi: "Oman",
    },
  },
  pakistan: {
    label: {
      en: "Pakistan",
      vi: "Pakistan",
    },
  },
  palau: {
    label: {
      en: "Palau",
      vi: "Palau",
    },
  },
  "palestinian_territory,_occupied": {
    label: {
      en: "Palestinian Territory, Occupied",
      vi: "Palestinian Territory, Occupied",
    },
  },
  panama: {
    label: {
      en: "Panama",
      vi: "Panama",
    },
  },
  papua_new_guinea: {
    label: {
      en: "Papua New Guinea",
      vi: "Papua New Guinea",
    },
  },
  paraguay: {
    label: {
      en: "Paraguay",
      vi: "Paraguay",
    },
  },
  peru: {
    label: {
      en: "Peru",
      vi: "Peru",
    },
  },
  philippines: {
    label: {
      en: "Philippines",
      vi: "Philippines",
    },
  },
  pitcairn: {
    label: {
      en: "Pitcairn",
      vi: "Pitcairn",
    },
  },
  poland: {
    label: {
      en: "Poland",
      vi: "Poland",
    },
  },
  portugal: {
    label: {
      en: "Portugal",
      vi: "Portugal",
    },
  },
  puerto_rico: {
    label: {
      en: "Puerto Rico",
      vi: "Puerto Rico",
    },
  },
  qatar: {
    label: {
      en: "Qatar",
      vi: "Qatar",
    },
  },
  reunion: {
    label: {
      en: "Reunion",
      vi: "Reunion",
    },
  },
  romania: {
    label: {
      en: "Romania",
      vi: "Romania",
    },
  },
  russian_federation: {
    label: {
      en: "Russian Federation",
      vi: "Russian Federation",
    },
  },
  rwanda: {
    label: {
      en: "Rwanda",
      vi: "Rwanda",
    },
  },
  saint_helena: {
    label: {
      en: "Saint Helena",
      vi: "Saint Helena",
    },
  },
  saint_kitts_and_nevis: {
    label: {
      en: "Saint Kitts and Nevis",
      vi: "Saint Kitts and Nevis",
    },
  },
  saint_lucia: {
    label: {
      en: "Saint Lucia",
      vi: "Saint Lucia",
    },
  },
  saint_pierre_and_miquelon: {
    label: {
      en: "Saint Pierre and Miquelon",
      vi: "Saint Pierre and Miquelon",
    },
  },
  saint_vincent_and_the_grenadines: {
    label: {
      en: "Saint Vincent and the Grenadines",
      vi: "Saint Vincent and the Grenadines",
    },
  },
  samoa: {
    label: {
      en: "Samoa",
      vi: "Samoa",
    },
  },
  san_marino: {
    label: {
      en: "San Marino",
      vi: "San Marino",
    },
  },
  sao_tome_and_principe: {
    label: {
      en: "Sao Tome and Principe",
      vi: "Sao Tome and Principe",
    },
  },
  saudi_arabia: {
    label: {
      en: "Saudi Arabia",
      vi: "Saudi Arabia",
    },
  },
  senegal: {
    label: {
      en: "Senegal",
      vi: "Senegal",
    },
  },
  serbia: {
    label: {
      en: "Serbia",
      vi: "Serbia",
    },
  },
  seychelles: {
    label: {
      en: "Seychelles",
      vi: "Seychelles",
    },
  },
  sierra_leone: {
    label: {
      en: "Sierra Leone",
      vi: "Sierra Leone",
    },
  },
  singapore: {
    label: {
      en: "Singapore",
      vi: "Singapore",
    },
  },
  slovakia: {
    label: {
      en: "Slovakia",
      vi: "Slovakia",
    },
  },
  slovenia: {
    label: {
      en: "Slovenia",
      vi: "Slovenia",
    },
  },
  solomon_islands: {
    label: {
      en: "Solomon Islands",
      vi: "Solomon Islands",
    },
  },
  somalia: {
    label: {
      en: "Somalia",
      vi: "Somalia",
    },
  },
  south_africa: {
    label: {
      en: "South Africa",
      vi: "South Africa",
    },
  },
  south_georgia_and_the_south_sandwich_islands: {
    label: {
      en: "South Georgia and the South Sandwich Islands",
      vi: "South Georgia and the South Sandwich Islands",
    },
  },
  spain: {
    label: {
      en: "Spain",
      vi: "Spain",
    },
  },
  sri_lanka: {
    label: {
      en: "Sri Lanka",
      vi: "Sri Lanka",
    },
  },
  sudan: {
    label: {
      en: "Sudan",
      vi: "Sudan",
    },
  },
  suriname: {
    label: {
      en: "Suriname",
      vi: "Suriname",
    },
  },
  svalbard_and_jan_mayen: {
    label: {
      en: "Svalbard and Jan Mayen",
      vi: "Svalbard and Jan Mayen",
    },
  },
  swaziland: {
    label: {
      en: "Swaziland",
      vi: "Swaziland",
    },
  },
  sweden: {
    label: {
      en: "Sweden",
      vi: "Sweden",
    },
  },
  switzerland: {
    label: {
      en: "Switzerland",
      vi: "Switzerland",
    },
  },
  syrian_arab_republic: {
    label: {
      en: "Syrian Arab Republic",
      vi: "Syrian Arab Republic",
    },
  },
  taiwan: {
    label: {
      en: "Taiwan",
      vi: "Taiwan",
    },
  },
  tajikistan: {
    label: {
      en: "Tajikistan",
      vi: "Tajikistan",
    },
  },
  "tanzania,_united_republic_of": {
    label: {
      en: "Tanzania, United Republic of",
      vi: "Tanzania, United Republic of",
    },
  },
  thailand: {
    label: {
      en: "Thailand",
      vi: "Thailand",
    },
  },
  "timor-leste": {
    label: {
      en: "Timor-Leste",
      vi: "Timor-Leste",
    },
  },
  togo: {
    label: {
      en: "Togo",
      vi: "Togo",
    },
  },
  tokelau: {
    label: {
      en: "Tokelau",
      vi: "Tokelau",
    },
  },
  tonga: {
    label: {
      en: "Tonga",
      vi: "Tonga",
    },
  },
  trinidad_and_tobago: {
    label: {
      en: "Trinidad and Tobago",
      vi: "Trinidad and Tobago",
    },
  },
  tunisia: {
    label: {
      en: "Tunisia",
      vi: "Tunisia",
    },
  },
  turkey: {
    label: {
      en: "Turkey",
      vi: "Turkey",
    },
  },
  turkmenistan: {
    label: {
      en: "Turkmenistan",
      vi: "Turkmenistan",
    },
  },
  turks_and_caicos_islands: {
    label: {
      en: "Turks and Caicos Islands",
      vi: "Turks and Caicos Islands",
    },
  },
  tuvalu: {
    label: {
      en: "Tuvalu",
      vi: "Tuvalu",
    },
  },
  uganda: {
    label: {
      en: "Uganda",
      vi: "Uganda",
    },
  },
  ukraine: {
    label: {
      en: "Ukraine",
      vi: "Ukraine",
    },
  },
  united_arab_emirates: {
    label: {
      en: "United Arab Emirates",
      vi: "United Arab Emirates",
    },
  },
  united_kingdom: {
    label: {
      en: "United Kingdom",
      vi: "United Kingdom",
    },
  },
  united_states: {
    label: {
      en: "United States",
      vi: "United States",
    },
  },
  united_states_minor_outlying_islands: {
    label: {
      en: "United States Minor Outlying Islands",
      vi: "United States Minor Outlying Islands",
    },
  },
  uruguay: {
    label: {
      en: "Uruguay",
      vi: "Uruguay",
    },
  },
  uzbekistan: {
    label: {
      en: "Uzbekistan",
      vi: "Uzbekistan",
    },
  },
  vanuatu: {
    label: {
      en: "Vanuatu",
      vi: "Vanuatu",
    },
  },
  venezuela: {
    label: {
      en: "Venezuela",
      vi: "Venezuela",
    },
  },
  virgin_islands_british: {
    label: {
      en: "Virgin Islands, British",
      vi: "Virgin Islands, British",
    },
  },
  virgin_islands_us: {
    label: {
      en: "Virgin Islands, U.S.",
      vi: "Virgin Islands, U.S.",
    },
  },
  wallis_and_futuna: {
    label: {
      en: "Wallis and Futuna",
      vi: "Wallis and Futuna",
    },
  },
  western_sahara: {
    label: {
      en: "Western Sahara",
      vi: "Western Sahara",
    },
  },
  yemen: {
    label: {
      en: "Yemen",
      vi: "Yemen",
    },
  },
  zambia: {
    label: {
      en: "Zambia",
      vi: "Zambia",
    },
  },
  zimbabwe: {
    label: {
      en: "Zimbabwe",
      vi: "Zimbabwe",
    },
  },
};

export const COUNTRY_OBJECT = {
  Vietnam: {
    label: {
      en: "Vietnam",
      vi: "Việt Nam",
    },
  },
  afghanistan: {
    label: {
      en: "Afghanistan",
      vi: "Afghanistan",
    },
  },
  aland_islands: {
    label: {
      en: "Åland Islands",
      vi: "Åland Islands",
    },
  },
  albania: {
    label: {
      en: "Albania",
      vi: "Albania",
    },
  },
  algeria: {
    label: {
      en: "Algeria",
      vi: "Algeria",
    },
  },
  american_samoa: {
    label: {
      en: "American Samoa",
      vi: "American Samoa",
    },
  },
  andorra: {
    label: {
      en: "Andorra",
      vi: "Andorra",
    },
  },
  angola: {
    label: {
      en: "Angola",
      vi: "Angola",
    },
  },
  anguilla: {
    label: {
      en: "Anguilla",
      vi: "Anguilla",
    },
  },
  antarctica: {
    label: {
      en: "Antarctica",
      vi: "Antarctica",
    },
  },
  antigua_and_barbuda: {
    label: {
      en: "Antigua and Barbuda",
      vi: "Antigua and Barbuda",
    },
  },
  argentina: {
    label: {
      en: "Argentina",
      vi: "Argentina",
    },
  },
  armenia: {
    label: {
      en: "Armenia",
      vi: "Armenia",
    },
  },
  aruba: {
    label: {
      en: "Aruba",
      vi: "Aruba",
    },
  },
  australia: {
    label: {
      en: "Australia",
      vi: "Australia",
    },
  },
  austria: {
    label: {
      en: "Austria",
      vi: "Austria",
    },
  },
  azerbaijan: {
    label: {
      en: "Azerbaijan",
      vi: "Azerbaijan",
    },
  },
  bahamas: {
    label: {
      en: "Bahamas",
      vi: "Bahamas",
    },
  },
  bahrain: {
    label: {
      en: "Bahrain",
      vi: "Bahrain",
    },
  },
  bangladesh: {
    label: {
      en: "Bangladesh",
      vi: "Bangladesh",
    },
  },
  barbados: {
    label: {
      en: "Barbados",
      vi: "Barbados",
    },
  },
  belarus: {
    label: {
      en: "Belarus",
      vi: "Belarus",
    },
  },
  belgium: {
    label: {
      en: "Belgium",
      vi: "Belgium",
    },
  },
  belize: {
    label: {
      en: "Belize",
      vi: "Belize",
    },
  },
  benin: {
    label: {
      en: "Benin",
      vi: "Benin",
    },
  },
  bermuda: {
    label: {
      en: "Bermuda",
      vi: "Bermuda",
    },
  },
  bhutan: {
    label: {
      en: "Bhutan",
      vi: "Bhutan",
    },
  },
  bolivia: {
    label: {
      en: "Bolivia",
      vi: "Bolivia",
    },
  },
  bosnia_and_herzegovina: {
    label: {
      en: "Bosnia and Herzegovina",
      vi: "Bosnia and Herzegovina",
    },
  },
  botswana: {
    label: {
      en: "Botswana",
      vi: "Botswana",
    },
  },
  bouvet_island: {
    label: {
      en: "Bouvet Island",
      vi: "Bouvet Island",
    },
  },
  brazil: {
    label: {
      en: "Brazil",
      vi: "Brazil",
    },
  },
  british_indian_ocean_territory: {
    label: {
      en: "British Indian Ocean Territory",
      vi: "British Indian Ocean Territory",
    },
  },
  brunei_darussalam: {
    label: {
      en: "Brunei Darussalam",
      vi: "Brunei Darussalam",
    },
  },
  bulgaria: {
    label: {
      en: "Bulgaria",
      vi: "Bulgaria",
    },
  },
  burkina_faso: {
    label: {
      en: "Burkina Faso",
      vi: "Burkina Faso",
    },
  },
  burundi: {
    label: {
      en: "Burundi",
      vi: "Burundi",
    },
  },
  cambodia: {
    label: {
      en: "Cambodia",
      vi: "Cambodia",
    },
  },
  cameroon: {
    label: {
      en: "Cameroon",
      vi: "Cameroon",
    },
  },
  canada: {
    label: {
      en: "Canada",
      vi: "Canada",
    },
  },
  cape_verde: {
    label: {
      en: "Cape Verde",
      vi: "Cape Verde",
    },
  },
  cayman_islands: {
    label: {
      en: "Cayman Islands",
      vi: "Cayman Islands",
    },
  },
  central_african_republic: {
    label: {
      en: "Central African Republic",
      vi: "Central African Republic",
    },
  },
  chad: {
    label: {
      en: "Chad",
      vi: "Chad",
    },
  },
  chile: {
    label: {
      en: "Chile",
      vi: "Chile",
    },
  },
  china: {
    label: {
      en: "China",
      vi: "China",
    },
  },
  christmas_island: {
    label: {
      en: "Christmas Island",
      vi: "Christmas Island",
    },
  },
  cocos_keeling_islands: {
    label: {
      en: "Cocos (Keeling) Islands",
      vi: "Cocos (Keeling) Islands",
    },
  },
  colombia: {
    label: {
      en: "Colombia",
      vi: "Colombia",
    },
  },
  comoros: {
    label: {
      en: "Comoros",
      vi: "Comoros",
    },
  },
  congo: {
    label: {
      en: "Congo",
      vi: "Congo",
    },
  },
  congo_the_democratic_republic_of_the: {
    label: {
      en: "Congo, The Democratic Republic of the",
      vi: "Congo, The Democratic Republic of the",
    },
  },
  cook_islands: {
    label: {
      en: "Cook Islands",
      vi: "Cook Islands",
    },
  },
  costa_rica: {
    label: {
      en: "Costa Rica",
      vi: "Costa Rica",
    },
  },
  cote_d_ivoire: {
    label: {
      en: "Cote D'Ivoire",
      vi: "Cote D'Ivoire",
    },
  },
  croatia: {
    label: {
      en: "Croatia",
      vi: "Croatia",
    },
  },
  cuba: {
    label: {
      en: "Cuba",
      vi: "Cuba",
    },
  },
  cyprus: {
    label: {
      en: "Cyprus",
      vi: "Cyprus",
    },
  },
  czech_republic: {
    label: {
      en: "Czech Republic",
      vi: "Czech Republic",
    },
  },
  denmark: {
    label: {
      en: "Denmark",
      vi: "Denmark",
    },
  },
  djibouti: {
    label: {
      en: "Djibouti",
      vi: "Djibouti",
    },
  },
  dominica: {
    label: {
      en: "Dominica",
      vi: "Dominica",
    },
  },
  dominican_republic: {
    label: {
      en: "Dominican Republic",
      vi: "Dominican Republic",
    },
  },
  ecuador: {
    label: {
      en: "Ecuador",
      vi: "Ecuador",
    },
  },
  egypt: {
    label: {
      en: "Egypt",
      vi: "Egypt",
    },
  },
  el_salvador: {
    label: {
      en: "El Salvador",
      vi: "El Salvador",
    },
  },
  equatorial_guinea: {
    label: {
      en: "Equatorial Guinea",
      vi: "Equatorial Guinea",
    },
  },
  eritrea: {
    label: {
      en: "Eritrea",
      vi: "Eritrea",
    },
  },
  estonia: {
    label: {
      en: "Estonia",
      vi: "Estonia",
    },
  },
  ethiopia: {
    label: {
      en: "Ethiopia",
      vi: "Ethiopia",
    },
  },
  falkland_islands_malvinas: {
    label: {
      en: "Falkland Islands (Malvinas)",
      vi: "Falkland Islands (Malvinas)",
    },
  },
  faroe_islands: {
    label: {
      en: "Faroe Islands",
      vi: "Faroe Islands",
    },
  },
  fiji: {
    label: {
      en: "Fiji",
      vi: "Fiji",
    },
  },
  finland: {
    label: {
      en: "Finland",
      vi: "Finland",
    },
  },
  france: {
    label: {
      en: "France",
      vi: "France",
    },
  },
  french_guiana: {
    label: {
      en: "French Guiana",
      vi: "French Guiana",
    },
  },
  french_polynesia: {
    label: {
      en: "French Polynesia",
      vi: "French Polynesia",
    },
  },
  french_southern_territories: {
    label: {
      en: "French Southern Territories",
      vi: "French Southern Territories",
    },
  },
  gabon: {
    label: {
      en: "Gabon",
      vi: "Gabon",
    },
  },
  gambia: {
    label: {
      en: "Gambia",
      vi: "Gambia",
    },
  },
  georgia: {
    label: {
      en: "Georgia",
      vi: "Georgia",
    },
  },
  germany: {
    label: {
      en: "Germany",
      vi: "Germany",
    },
  },
  ghana: {
    label: {
      en: "Ghana",
      vi: "Ghana",
    },
  },
  gibraltar: {
    label: {
      en: "Gibraltar",
      vi: "Gibraltar",
    },
  },
  greece: {
    label: {
      en: "Greece",
      vi: "Greece",
    },
  },
  greenland: {
    label: {
      en: "Greenland",
      vi: "Greenland",
    },
  },
  grenada: {
    label: {
      en: "Grenada",
      vi: "Grenada",
    },
  },
  guadeloupe: {
    label: {
      en: "Guadeloupe",
      vi: "Guadeloupe",
    },
  },
  guam: {
    label: {
      en: "Guam",
      vi: "Guam",
    },
  },
  guatemala: {
    label: {
      en: "Guatemala",
      vi: "Guatemala",
    },
  },
  guernsey: {
    label: {
      en: "Guernsey",
      vi: "Guernsey",
    },
  },
  guinea: {
    label: {
      en: "Guinea",
      vi: "Guinea",
    },
  },
  "guinea-bissau": {
    label: {
      en: "Guinea-Bissau",
      vi: "Guinea-Bissau",
    },
  },
  guyana: {
    label: {
      en: "Guyana",
      vi: "Guyana",
    },
  },
  haiti: {
    label: {
      en: "Haiti",
      vi: "Haiti",
    },
  },
  heard_island_and_mcdonald_islands: {
    label: {
      en: "Heard Island and Mcdonald Islands",
      vi: "Heard Island and Mcdonald Islands",
    },
  },
  holy_see_vatican_city_state: {
    label: {
      en: "Holy See (Vatican City State)",
      vi: "Holy See (Vatican City State)",
    },
  },
  honduras: {
    label: {
      en: "Honduras",
      vi: "Honduras",
    },
  },
  hong_kong: {
    label: {
      en: "Hong Kong",
      vi: "Hong Kong",
    },
  },
  hungary: {
    label: {
      en: "Hungary",
      vi: "Hungary",
    },
  },
  iceland: {
    label: {
      en: "Iceland",
      vi: "Iceland",
    },
  },
  india: {
    label: {
      en: "India",
      vi: "India",
    },
  },
  indonesia: {
    label: {
      en: "Indonesia",
      vi: "Indonesia",
    },
  },
  iran_islamic_republic_of: {
    label: {
      en: "Iran, Islamic Republic Of",
      vi: "Iran, Islamic Republic Of",
    },
  },
  iraq: {
    label: {
      en: "Iraq",
      vi: "Iraq",
    },
  },
  ireland: {
    label: {
      en: "Ireland",
      vi: "Ireland",
    },
  },
  isle_of_man: {
    label: {
      en: "Isle of Man",
      vi: "Isle of Man",
    },
  },
  israel: {
    label: {
      en: "Israel",
      vi: "Israel",
    },
  },
  italy: {
    label: {
      en: "Italy",
      vi: "Italy",
    },
  },
  jamaica: {
    label: {
      en: "Jamaica",
      vi: "Jamaica",
    },
  },
  japan: {
    label: {
      en: "Japan",
      vi: "Japan",
    },
  },
  jersey: {
    label: {
      en: "Jersey",
      vi: "Jersey",
    },
  },
  jordan: {
    label: {
      en: "Jordan",
      vi: "Jordan",
    },
  },
  kazakhstan: {
    label: {
      en: "Kazakhstan",
      vi: "Kazakhstan",
    },
  },
  kenya: {
    label: {
      en: "Kenya",
      vi: "Kenya",
    },
  },
  kiribati: {
    label: {
      en: "Kiribati",
      vi: "Kiribati",
    },
  },
  "democratic_people's_republic_of_korea": {
    label: {
      en: "Democratic People's Republic of Korea",
      vi: "Democratic People's Republic of Korea",
    },
  },
  korea_republic_of: {
    label: {
      en: "Korea, Republic of",
      vi: "Korea, Republic of",
    },
  },
  kosovo: {
    label: {
      en: "Kosovo",
      vi: "Kosovo",
    },
  },
  kuwait: {
    label: {
      en: "Kuwait",
      vi: "Kuwait",
    },
  },
  kyrgyzstan: {
    label: {
      en: "Kyrgyzstan",
      vi: "Kyrgyzstan",
    },
  },
  "lao_people's_democratic_republic": {
    label: {
      en: "Lao People's Democratic Republic",
      vi: "Lao People's Democratic Republic",
    },
  },
  latvia: {
    label: {
      en: "Latvia",
      vi: "Latvia",
    },
  },
  lebanon: {
    label: {
      en: "Lebanon",
      vi: "Lebanon",
    },
  },
  lesotho: {
    label: {
      en: "Lesotho",
      vi: "Lesotho",
    },
  },
  liberia: {
    label: {
      en: "Liberia",
      vi: "Liberia",
    },
  },
  libyan_arab_jamahiriya: {
    label: {
      en: "Libyan Arab Jamahiriya",
      vi: "Libyan Arab Jamahiriya",
    },
  },
  liechtenstein: {
    label: {
      en: "Liechtenstein",
      vi: "Liechtenstein",
    },
  },
  lithuania: {
    label: {
      en: "Lithuania",
      vi: "Lithuania",
    },
  },
  luxembourg: {
    label: {
      en: "Luxembourg",
      vi: "Luxembourg",
    },
  },
  macao: {
    label: {
      en: "Macao",
      vi: "Macao",
    },
  },
  "macedonia,_the_former_yugoslav_republic_of": {
    label: {
      en: "Macedonia, The Former Yugoslav Republic of",
      vi: "Macedonia, The Former Yugoslav Republic of",
    },
  },
  madagascar: {
    label: {
      en: "Madagascar",
      vi: "Madagascar",
    },
  },
  malawi: {
    label: {
      en: "Malawi",
      vi: "Malawi",
    },
  },
  malaysia: {
    label: {
      en: "Malaysia",
      vi: "Malaysia",
    },
  },
  maldives: {
    label: {
      en: "Maldives",
      vi: "Maldives",
    },
  },
  mali: {
    label: {
      en: "Mali",
      vi: "Mali",
    },
  },
  malta: {
    label: {
      en: "Malta",
      vi: "Malta",
    },
  },
  marshall_islands: {
    label: {
      en: "Marshall Islands",
      vi: "Marshall Islands",
    },
  },
  martinique: {
    label: {
      en: "Martinique",
      vi: "Martinique",
    },
  },
  mauritania: {
    label: {
      en: "Mauritania",
      vi: "Mauritania",
    },
  },
  mauritius: {
    label: {
      en: "Mauritius",
      vi: "Mauritius",
    },
  },
  mayotte: {
    label: {
      en: "Mayotte",
      vi: "Mayotte",
    },
  },
  mexico: {
    label: {
      en: "Mexico",
      vi: "Mexico",
    },
  },
  "micronesia,_federated_states_of": {
    label: {
      en: "Micronesia, Federated States of",
      vi: "Micronesia, Federated States of",
    },
  },
  moldova_republic_of: {
    label: {
      en: "Moldova, Republic of",
      vi: "Moldova, Republic of",
    },
  },
  monaco: {
    label: {
      en: "Monaco",
      vi: "Monaco",
    },
  },
  mongolia: {
    label: {
      en: "Mongolia",
      vi: "Mongolia",
    },
  },
  montenegro: {
    label: {
      en: "Montenegro",
      vi: "Montenegro",
    },
  },
  montserrat: {
    label: {
      en: "Montserrat",
      vi: "Montserrat",
    },
  },
  morocco: {
    label: {
      en: "Morocco",
      vi: "Morocco",
    },
  },
  mozambique: {
    label: {
      en: "Mozambique",
      vi: "Mozambique",
    },
  },
  myanmar: {
    label: {
      en: "Myanmar",
      vi: "Myanmar",
    },
  },
  namibia: {
    label: {
      en: "Namibia",
      vi: "Namibia",
    },
  },
  nauru: {
    label: {
      en: "Nauru",
      vi: "Nauru",
    },
  },
  nepal: {
    label: {
      en: "Nepal",
      vi: "Nepal",
    },
  },
  netherlands: {
    label: {
      en: "Netherlands",
      vi: "Netherlands",
    },
  },
  netherlands_antilles: {
    label: {
      en: "Netherlands Antilles",
      vi: "Netherlands Antilles",
    },
  },
  new_caledonia: {
    label: {
      en: "New Caledonia",
      vi: "New Caledonia",
    },
  },
  new_zealand: {
    label: {
      en: "New Zealand",
      vi: "New Zealand",
    },
  },
  nicaragua: {
    label: {
      en: "Nicaragua",
      vi: "Nicaragua",
    },
  },
  niger: {
    label: {
      en: "Niger",
      vi: "Niger",
    },
  },
  nigeria: {
    label: {
      en: "Nigeria",
      vi: "Nigeria",
    },
  },
  niue: {
    label: {
      en: "Niue",
      vi: "Niue",
    },
  },
  norfolk_island: {
    label: {
      en: "Norfolk Island",
      vi: "Norfolk Island",
    },
  },
  northern_mariana_islands: {
    label: {
      en: "Northern Mariana Islands",
      vi: "Northern Mariana Islands",
    },
  },
  norway: {
    label: {
      en: "Norway",
      vi: "Norway",
    },
  },
  oman: {
    label: {
      en: "Oman",
      vi: "Oman",
    },
  },
  pakistan: {
    label: {
      en: "Pakistan",
      vi: "Pakistan",
    },
  },
  palau: {
    label: {
      en: "Palau",
      vi: "Palau",
    },
  },
  "palestinian_territory,_occupied": {
    label: {
      en: "Palestinian Territory, Occupied",
      vi: "Palestinian Territory, Occupied",
    },
  },
  panama: {
    label: {
      en: "Panama",
      vi: "Panama",
    },
  },
  papua_new_guinea: {
    label: {
      en: "Papua New Guinea",
      vi: "Papua New Guinea",
    },
  },
  paraguay: {
    label: {
      en: "Paraguay",
      vi: "Paraguay",
    },
  },
  peru: {
    label: {
      en: "Peru",
      vi: "Peru",
    },
  },
  philippines: {
    label: {
      en: "Philippines",
      vi: "Philippines",
    },
  },
  pitcairn: {
    label: {
      en: "Pitcairn",
      vi: "Pitcairn",
    },
  },
  poland: {
    label: {
      en: "Poland",
      vi: "Poland",
    },
  },
  portugal: {
    label: {
      en: "Portugal",
      vi: "Portugal",
    },
  },
  puerto_rico: {
    label: {
      en: "Puerto Rico",
      vi: "Puerto Rico",
    },
  },
  qatar: {
    label: {
      en: "Qatar",
      vi: "Qatar",
    },
  },
  reunion: {
    label: {
      en: "Reunion",
      vi: "Reunion",
    },
  },
  romania: {
    label: {
      en: "Romania",
      vi: "Romania",
    },
  },
  russian_federation: {
    label: {
      en: "Russian Federation",
      vi: "Russian Federation",
    },
  },
  rwanda: {
    label: {
      en: "Rwanda",
      vi: "Rwanda",
    },
  },
  saint_helena: {
    label: {
      en: "Saint Helena",
      vi: "Saint Helena",
    },
  },
  saint_kitts_and_nevis: {
    label: {
      en: "Saint Kitts and Nevis",
      vi: "Saint Kitts and Nevis",
    },
  },
  saint_lucia: {
    label: {
      en: "Saint Lucia",
      vi: "Saint Lucia",
    },
  },
  saint_pierre_and_miquelon: {
    label: {
      en: "Saint Pierre and Miquelon",
      vi: "Saint Pierre and Miquelon",
    },
  },
  saint_vincent_and_the_grenadines: {
    label: {
      en: "Saint Vincent and the Grenadines",
      vi: "Saint Vincent and the Grenadines",
    },
  },
  samoa: {
    label: {
      en: "Samoa",
      vi: "Samoa",
    },
  },
  san_marino: {
    label: {
      en: "San Marino",
      vi: "San Marino",
    },
  },
  sao_tome_and_principe: {
    label: {
      en: "Sao Tome and Principe",
      vi: "Sao Tome and Principe",
    },
  },
  saudi_arabia: {
    label: {
      en: "Saudi Arabia",
      vi: "Saudi Arabia",
    },
  },
  senegal: {
    label: {
      en: "Senegal",
      vi: "Senegal",
    },
  },
  serbia: {
    label: {
      en: "Serbia",
      vi: "Serbia",
    },
  },
  seychelles: {
    label: {
      en: "Seychelles",
      vi: "Seychelles",
    },
  },
  sierra_leone: {
    label: {
      en: "Sierra Leone",
      vi: "Sierra Leone",
    },
  },
  singapore: {
    label: {
      en: "Singapore",
      vi: "Singapore",
    },
  },
  slovakia: {
    label: {
      en: "Slovakia",
      vi: "Slovakia",
    },
  },
  slovenia: {
    label: {
      en: "Slovenia",
      vi: "Slovenia",
    },
  },
  solomon_islands: {
    label: {
      en: "Solomon Islands",
      vi: "Solomon Islands",
    },
  },
  somalia: {
    label: {
      en: "Somalia",
      vi: "Somalia",
    },
  },
  south_africa: {
    label: {
      en: "South Africa",
      vi: "South Africa",
    },
  },
  south_georgia_and_the_south_sandwich_islands: {
    label: {
      en: "South Georgia and the South Sandwich Islands",
      vi: "South Georgia and the South Sandwich Islands",
    },
  },
  spain: {
    label: {
      en: "Spain",
      vi: "Spain",
    },
  },
  sri_lanka: {
    label: {
      en: "Sri Lanka",
      vi: "Sri Lanka",
    },
  },
  sudan: {
    label: {
      en: "Sudan",
      vi: "Sudan",
    },
  },
  suriname: {
    label: {
      en: "Suriname",
      vi: "Suriname",
    },
  },
  svalbard_and_jan_mayen: {
    label: {
      en: "Svalbard and Jan Mayen",
      vi: "Svalbard and Jan Mayen",
    },
  },
  swaziland: {
    label: {
      en: "Swaziland",
      vi: "Swaziland",
    },
  },
  sweden: {
    label: {
      en: "Sweden",
      vi: "Sweden",
    },
  },
  switzerland: {
    label: {
      en: "Switzerland",
      vi: "Switzerland",
    },
  },
  syrian_arab_republic: {
    label: {
      en: "Syrian Arab Republic",
      vi: "Syrian Arab Republic",
    },
  },
  taiwan: {
    label: {
      en: "Taiwan",
      vi: "Taiwan",
    },
  },
  tajikistan: {
    label: {
      en: "Tajikistan",
      vi: "Tajikistan",
    },
  },
  "tanzania,_united_republic_of": {
    label: {
      en: "Tanzania, United Republic of",
      vi: "Tanzania, United Republic of",
    },
  },
  thailand: {
    label: {
      en: "Thailand",
      vi: "Thailand",
    },
  },
  "timor-leste": {
    label: {
      en: "Timor-Leste",
      vi: "Timor-Leste",
    },
  },
  togo: {
    label: {
      en: "Togo",
      vi: "Togo",
    },
  },
  tokelau: {
    label: {
      en: "Tokelau",
      vi: "Tokelau",
    },
  },
  tonga: {
    label: {
      en: "Tonga",
      vi: "Tonga",
    },
  },
  trinidad_and_tobago: {
    label: {
      en: "Trinidad and Tobago",
      vi: "Trinidad and Tobago",
    },
  },
  tunisia: {
    label: {
      en: "Tunisia",
      vi: "Tunisia",
    },
  },
  turkey: {
    label: {
      en: "Turkey",
      vi: "Turkey",
    },
  },
  turkmenistan: {
    label: {
      en: "Turkmenistan",
      vi: "Turkmenistan",
    },
  },
  turks_and_caicos_islands: {
    label: {
      en: "Turks and Caicos Islands",
      vi: "Turks and Caicos Islands",
    },
  },
  tuvalu: {
    label: {
      en: "Tuvalu",
      vi: "Tuvalu",
    },
  },
  uganda: {
    label: {
      en: "Uganda",
      vi: "Uganda",
    },
  },
  ukraine: {
    label: {
      en: "Ukraine",
      vi: "Ukraine",
    },
  },
  united_arab_emirates: {
    label: {
      en: "United Arab Emirates",
      vi: "United Arab Emirates",
    },
  },
  united_kingdom: {
    label: {
      en: "United Kingdom",
      vi: "United Kingdom",
    },
  },
  united_states: {
    label: {
      en: "United States",
      vi: "United States",
    },
  },
  united_states_minor_outlying_islands: {
    label: {
      en: "United States Minor Outlying Islands",
      vi: "United States Minor Outlying Islands",
    },
  },
  uruguay: {
    label: {
      en: "Uruguay",
      vi: "Uruguay",
    },
  },
  uzbekistan: {
    label: {
      en: "Uzbekistan",
      vi: "Uzbekistan",
    },
  },
  vanuatu: {
    label: {
      en: "Vanuatu",
      vi: "Vanuatu",
    },
  },
  venezuela: {
    label: {
      en: "Venezuela",
      vi: "Venezuela",
    },
  },
  virgin_islands_british: {
    label: {
      en: "Virgin Islands, British",
      vi: "Virgin Islands, British",
    },
  },
  virgin_islands_us: {
    label: {
      en: "Virgin Islands, U.S.",
      vi: "Virgin Islands, U.S.",
    },
  },
  wallis_and_futuna: {
    label: {
      en: "Wallis and Futuna",
      vi: "Wallis and Futuna",
    },
  },
  western_sahara: {
    label: {
      en: "Western Sahara",
      vi: "Western Sahara",
    },
  },
  yemen: {
    label: {
      en: "Yemen",
      vi: "Yemen",
    },
  },
  zambia: {
    label: {
      en: "Zambia",
      vi: "Zambia",
    },
  },
  zimbabwe: {
    label: {
      en: "Zimbabwe",
      vi: "Zimbabwe",
    },
  },
};

export const GENDER_OBJECT = {
  "Nam/ Male": {
    label: {
      en: "Male",
      vi: "Nam",
    },
  },
  "Nữ/ Female": {
    label: {
      en: "Female",
      vi: "Nữ",
    },
  },
};

export const PROVINCE_OBJECT = {
  Ha_noi: {
    label: {
      en: "Ha Noi City",
      vi: "Thành phố Hà Nội",
    },
  },
  Ho_chi_minh: {
    label: {
      en: "Ho Chi Minh City",
      vi: "Thành phố Hồ Chí Minh",
    },
  },
  Hai_phong: {
    label: {
      en: "Hai Phong City",
      vi: "Thành phố Hải Phòng",
    },
  },
  Da_nang: {
    label: {
      en: "Da Nang City",
      vi: "Thành phố Đà Nẵng",
    },
  },
  Can_tho: {
    label: {
      en: "Can Tho City",
      vi: "Thành phố Cần Thơ",
    },
  },
  Hue: {
    label: {
      en: "Hue City",
      vi: "Thành phố Huế",
    },
  },
  An_giang: {
    label: {
      en: "An Giang",
      vi: "An Giang",
    },
  },
  Bac_ninh: {
    label: {
      en: "Bac Ninh",
      vi: "Bắc Ninh",
    },
  },
  Ca_mau: {
    label: {
      en: "Ca Mau",
      vi: "Cà Mau",
    },
  },
  Cao_bang: {
    label: {
      en: "Cao Bang",
      vi: "Cao Bằng",
    },
  },
  Dak_lak: {
    label: {
      en: "Dak Lak",
      vi: "Đắk Lắk",
    },
  },
  Dien_bien: {
    label: {
      en: "Dien Bien",
      vi: "Điện Biên",
    },
  },
  Dong_nai: {
    label: {
      en: "Dong Nai",
      vi: "Đồng Nai",
    },
  },
  Dong_thap: {
    label: {
      en: "Dong Thap",
      vi: "Đồng Tháp",
    },
  },
  Gia_lai: {
    label: {
      en: "Gia Lai",
      vi: "Gia Lai",
    },
  },
  Ha_tinh: {
    label: {
      en: "Ha Tinh",
      vi: "Hà Tĩnh",
    },
  },
  Hung_yen: {
    label: {
      en: "Hung Yen",
      vi: "Hưng Yên",
    },
  },
  Khanh_hoa: {
    label: {
      en: "Khanh Hoa",
      vi: "Khánh Hòa",
    },
  },
  Lai_chau: {
    label: {
      en: "Lai Chau",
      vi: "Lai Châu",
    },
  },
  Lam_dong: {
    label: {
      en: "Lam Dong",
      vi: "Lâm Đồng",
    },
  },
  Lang_son: {
    label: {
      en: "Lang Son",
      vi: "Lạng Sơn",
    },
  },
  Lao_cai: {
    label: {
      en: "Lao Cai",
      vi: "Lào Cai",
    },
  },
  Nghe_an: {
    label: {
      en: "Nghe An",
      vi: "Nghệ An",
    },
  },
  Ninh_binh: {
    label: {
      en: "Ninh Binh",
      vi: "Ninh Bình",
    },
  },
  Phu_tho: {
    label: {
      en: "Phu Tho",
      vi: "Phú Thọ",
    },
  },
  Quang_ngai: {
    label: {
      en: "Quang Ngai",
      vi: "Quảng Ngãi",
    },
  },
  Quang_ninh: {
    label: {
      en: "Quang Ninh",
      vi: "Quảng Ninh",
    },
  },
  Quang_tri: {
    label: {
      en: "Quang Tri",
      vi: "Quảng Trị",
    },
  },
  Son_la: {
    label: {
      en: "Son La",
      vi: "Sơn La",
    },
  },
  Tay_ninh: {
    label: {
      en: "Tay Ninh",
      vi: "Tây Ninh",
    },
  },
  Thai_nguyen: {
    label: {
      en: "Thai Nguyen",
      vi: "Thái Nguyên",
    },
  },
  Thanh_hoa: {
    label: {
      en: "Thanh Hoa",
      vi: "Thanh Hóa",
    },
  },
  Tuyen_quang: {
    label: {
      en: "Tuyen Quang",
      vi: "Tuyên Quang",
    },
  },
  Vinh_long: {
    label: {
      en: "Vinh Long",
      vi: "Vĩnh Long",
    },
  },
  Other: {
    label: {
      en: "Other",
      vi: "Khác/Other",
    },
  },
};

export const RELATIONSHIP_OBJECT = {
  "Mẹ - Con": {
    label: {
      en: "Mother-Child",
      vi: "Mẹ - Con",
    },
  },
  "Cha - Con": {
    label: {
      en: "Father-Child",
      vi: "Cha - Con",
    },
  },
  "Người thân": {
    label: {
      en: "Relatives",
      vi: "Người thân",
    },
  },
  Khác: {
    label: {
      en: "Other",
      vi: "Khác",
    },
  },
};

export const BLOOD_TYPE_OBJECT = {
  A: {
    label: {
      en: "A",
      vi: "A",
    },
  },
  B: {
    label: {
      en: "B",
      vi: "B",
    },
  },
  AB: {
    label: {
      en: "AB",
      vi: "AB",
    },
  },
  O: {
    label: {
      en: "O",
      vi: "O",
    },
  },
  "RH(D)+": {
    label: {
      en: "RH(D)+",
      vi: "RH(D)+",
    },
  },
  "RH(D)-": {
    label: {
      en: "RH(D)-",
      vi: "RH(D)-",
    },
  },
  No: {
    label: {
      en: "I don't know",
      vi: "Tôi không biết",
    },
  },
};

export const TSHIRT_SIZE_ARRAY = [
  {
    key: "XS",
    label: {
      en: "XS",
      vi: "XS",
    },
  },
  {
    key: "S",
    label: {
      en: "S",
      vi: "S",
    },
  },
  {
    key: "M",
    label: {
      en: "M",
      vi: "M",
    },
  },
  {
    key: "L",
    label: {
      en: "L",
      vi: "L",
    },
  },
  {
    key: "XL",
    label: {
      en: "XL",
      vi: "XL",
    },
  },
  {
    key: "2XL",
    label: {
      en: "2XL",
      vi: "2XL",
    },
  },
  {
    key: "3XL",
    label: {
      en: "3XL",
      vi: "3XL",
    },
  },
];

export const FINISHER_TSHIRT_SIZE_ARRAY = [
  {
    key: "XS",
    label: {
      en: "XS",
      vi: "XS",
    },
  },
  {
    key: "S",
    label: {
      en: "S",
      vi: "S",
    },
  },
  {
    key: "M",
    label: {
      en: "M",
      vi: "M",
    },
  },
  {
    key: "L",
    label: {
      en: "L",
      vi: "L",
    },
  },
  {
    key: "XL",
    label: {
      en: "XL",
      vi: "XL",
    },
  },
  {
    key: "2XL",
    label: {
      en: "2XL",
      vi: "2XL",
    },
  },
  {
    key: "3XL",
    label: {
      en: "3XL",
      vi: "3XL",
    },
  },
];

export const TEXT_FIELDS = {
  first_name: {
    label: {
      en: "First Name",
      vi: "Tên",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: true,
    key: "first_name",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.NONE,
    option: null,
  },
  last_name: {
    label: {
      en: "Last and middle name",
      vi: "Họ và tên đệm",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: true,
    key: "last_name",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.NONE,
    option: null,
  },
  phone: {
    label: {
      en: "Phone",
      vi: "Số điện thoại",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "phone",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.PHONE,
    option: null,
  },
  email: {
    label: {
      en: "Email",
      vi: "Địa chỉ email",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: true,
    key: "email",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.EMAIL,
    option: null,
  },
  id_card: {
    label: {
      en: "ID/Passport Number",
      vi: "CCCD hoặc hộ chiếu",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "id_card",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.LENGTH,
    option: {
      min: 5,
      max: 20,
    },
  },
  legal_full_name: {
    label: {
      en: "Full Name (Parent/ Guardian)",
      vi: "Họ và tên (Phụ huynh/ Người giám hộ)",
    },
    sub_label: {
      en: "Required for attendees under 18 years old.",
      vi: "Bắt buộc đối với Vận động viên dưới 18 tuổi.",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "legal_full_name",
    object: FieldObjectType.NONE,
    show: true,
    require: false,
    type: InputType.TEXT,
    validation: ValidationType.NONE,
    option: null,
  },
  legal_id_card: {
    label: {
      en: "ID/Passport Number (Parent/ Guardian)",
      vi: "CCCD hoặc hộ chiếu (Phụ huynh/ Người giám hộ)",
    },
    sub_label: {
      en: "Required for attendees under 18 years old.",
      vi: "Bắt buộc đối với Vận động viên dưới 18 tuổi.",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "legal_id_card",
    object: FieldObjectType.NONE,
    show: true,
    require: false,
    type: InputType.TEXT,
    validation: ValidationType.LENGTH,
    option: {
      min: 5,
      max: 20,
    },
  },
  legal_email: {
    label: {
      en: "Email (Parent/ Guardian)",
      vi: "Địa chỉ Email (Phụ huynh/ Người giám hộ)",
    },
    sub_label: {
      en: "Required for attendees under 18 years old.",
      vi: "Bắt buộc đối với Vận động viên dưới 18 tuổi.",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "legal_email",
    object: FieldObjectType.NONE,
    show: true,
    require: false,
    type: InputType.TEXT,
    validation: ValidationType.EMAIL,
    option: null,
  },
  allergy: {
    label: {
      en: "Medical Information",
      vi: "Thông tin y tế",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "allergy",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.NONE,
    option: null,
  },
  medicine: {
    label: {
      en: "Medicines are using",
      vi: "Loại thuốc đang dùng",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "medicine",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.NONE,
    option: null,
  },
  emergency_contact_name: {
    label: {
      en: "Emergency contact name",
      vi: "Tên người liên lạc khẩn cấp",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "emergency_contact_name",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.NONE,
    option: null,
  },
  emergency_contact_phone: {
    label: {
      en: "Emergency contact phone",
      vi: "Số điện thoại người liên lạc khẩn cấp",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "emergency_contact_phone",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.TEXT,
    validation: ValidationType.PHONE,
    option: null,
  },
  name_on_bib: {
    label: {
      en: "Name on bib",
      vi: "Tên trên bib",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "name_on_bib",
    object: FieldObjectType.NONE,
    show: true,
    require: false,
    type: InputType.TEXT,
    validation: ValidationType.LENGTH,
    option: {
      min: 0,
      max: 20,
    },
  },
};

export const SELECT_FIELDS = {
  country: {
    label: {
      en: "Country",
      vi: "Quốc gia",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "country",
    object: FieldObjectType.COUNTRIES,
    show: true,
    require: true,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: COUNTRY_OBJECT,
  },
  nationality: {
    label: {
      en: "Nationality",
      vi: "Quốc tịch",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "nationality",
    object: FieldObjectType.NATIONALITIES,
    show: true,
    require: true,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: NATIONALITIES_OBJECT,
  },
  province_living: {
    label: {
      en: "Where are you living?",
      vi: "Tỉnh/thành đang sinh sống",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "province_living",
    object: FieldObjectType.PROVINES,
    show: true,
    require: true,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: PROVINCE_OBJECT,
  },
  gender: {
    label: {
      en: "Gender",
      vi: "Giới tính",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "gender",
    object: FieldObjectType.GENDERS,
    show: true,
    require: true,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: GENDER_OBJECT,
  },
  runner_relationship: {
    label: {
      en: "Relationship with participant",
      vi: "Mối quan hệ với người tham gia",
    },
    sub_label: {
      en: "Required for attendees under 18 years old.",
      vi: "Bắt buộc đối với Vận động viên dưới 18 tuổi.",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "runner_relationship",
    object: FieldObjectType.RELATIONSHIP,
    show: true,
    require: false,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: RELATIONSHIP_OBJECT,
  },
  blood_type: {
    label: {
      en: "Blood type",
      vi: "Nhóm máu",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "blood_type",
    object: FieldObjectType.BLOOD_TYPE,
    show: true,
    require: true,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: BLOOD_TYPE_OBJECT,
  },
  t_shirt_size: {
    label: {
      en: "T-Shirt size",
      vi: "Cỡ áo",
    },
    sub_label: {
      en: "Size details",
      vi: "Chi tiết cỡ áo",
    },
    sub_label_url: "https://pix.actiup.net/2024/07/31/size-gemadept.jpg",
    is_lock_update_data: false,
    key: "t_shirt_size",
    object: FieldObjectType.TSHIRT_SIZE,
    show: true,
    require: true,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: TSHIRT_SIZE_ARRAY,
  },
  club: {
    label: {
      en: "Club",
      vi: "Câu lạc bộ",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "club",
    object: FieldObjectType.CLUBS,
    show: true,
    require: true,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: null,
  },
  t_shirt_size_finisher: {
    label: {
      en: "Finisher T-shirt size",
      vi: "Cỡ áo Finisher",
    },
    sub_label: {
      en: "Size details",
      vi: "Chi tiết cỡ áo",
    },
    sub_label_url: "https://pix.actiup.net/2024/07/31/size-gemadept.jpg",
    is_lock_update_data: false,
    key: "t_shirt_size_finisher",
    object: FieldObjectType.TSHIRT_SIZE_FINISHER,
    show: false,
    require: false,
    type: InputType.SELECT,
    validation: ValidationType.NONE,
    option: FINISHER_TSHIRT_SIZE_ARRAY,
  },
};

export const DATE_FIELDS = {
  dob: {
    label: {
      en: "Date of birth",
      vi: "Ngày sinh",
    },
    sub_label: {
      en: "",
      vi: "",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "dob",
    object: FieldObjectType.NONE,
    show: true,
    require: true,
    type: InputType.DATE,
    validation: ValidationType.DOB,
    option: {
      min: 12,
      max: 105,
      by: null,
    },
  },
  legal_birthday: {
    label: {
      en: "Date of birth (Parent/ Guardian)",
      vi: "Ngày sinh (Phụ huynh/ Người giám hộ)",
    },
    sub_label: {
      en: "Required for attendees under 18 years old.",
      vi: "Bắt buộc đối với Vận động viên dưới 18 tuổi.",
    },
    sub_label_url: "",
    is_lock_update_data: false,
    key: "legal_birthday",
    object: FieldObjectType.NONE,
    show: true,
    require: false,
    type: InputType.DATE,
    validation: ValidationType.DOB,
    option: {
      min: 18,
      max: 105,
    },
  },
};
